import { getCompanyAPI } from "./getCompanyAPI";
import { phpRequest } from "./phpRequest";

export const updateAccountAPI = async (
  accountID,
  company_id,
  invisible_companies,
  values,
  activeStatus,
  initAvatar,
  defaultImage
) => {
  let formData = new FormData();
  formData.append("id", accountID);
  formData.append("company_id", company_id);
  formData.append("invisible_companies", invisible_companies);
  formData.append("name", values.name);
  formData.append("email", values.email);
  formData.append("phone", values.phone);
  formData.append("password", values.password);
  formData.append("active_status", activeStatus === true ? 1 : 0);
  formData.append("otp_required", values.otp_required === true ? 1 : 0);
  formData.append(
    "roles[]",
    values.roleId
    // /^[a-zA-Z]+$/.test(values.role) ? values.roleId : values.role
  );
  if (values.file) {
    formData.append("avatar", values.file[0]);
    if (initAvatar !== defaultImage) {
      // if there is already an old image
      formData.append("old_avatar", initAvatar);
    } else {
      formData.append("old_avatar", defaultImage);
    }
  }
  await phpRequest.post("/account/update", formData);
  //update company and account in the localforage
  return getCompanyAPI(company_id);
};
